var map = {
	"./en/about.json": 593,
	"./en/app.json": 1831,
	"./en/general.json": 5575,
	"./zh-CN/about.json": 9496,
	"./zh-CN/app.json": 9843,
	"./zh-CN/general.json": 8308,
	"./zh-TW/about.json": 6498,
	"./zh-TW/app.json": 1652,
	"./zh-TW/general.json": 6403
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9259;